import { render, staticRenderFns } from "./auto-response-capsule.vue?vue&type=template&id=62c1aaf2&"
import script from "./auto-response-capsule.vue?vue&type=script&lang=ts&"
export * from "./auto-response-capsule.vue?vue&type=script&lang=ts&"
import style0 from "./auto-response-capsule.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports